import type { NewsArticle } from "@/mocks/news";
import { Link } from "react-router-dom";

interface Props {
  article: NewsArticle;
  size?: "default" | "compact";
}

export default function NewsCard({ article, size = "default" }: Props) {
  if (size === "compact") {
    return (
      <Link
        to={`/news/detail/${article.id}`}
        className="group flex cursor-pointer items-start gap-3 border-b border-background-200/80 py-3.5 last:border-b-0"
      >
        <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded bg-background-100 text-[11px] font-semibold text-primary-600">
          <i className="ri-article-line text-xs leading-none" />
        </span>
        <span className="min-w-0">
          <span className="line-clamp-2 block text-sm leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
            {article.title}
          </span>
          <span className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
            <span className="whitespace-nowrap">{article.date}</span>
            <span className="text-background-400">·</span>
            <span className="whitespace-nowrap">{article.tag}</span>
          </span>
        </span>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${article.id}`}
      className="group flex cursor-pointer flex-col rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors duration-300 hover:border-primary-300"
    >
      <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
        <span className="rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-900">{article.tag}</span>
        <span className="whitespace-nowrap">{article.date}</span>
        <span className="text-background-400">·</span>
        <span className="whitespace-nowrap">{article.author}</span>
      </div>
      <h3 className="mt-3 line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
        {article.title}
      </h3>
      <p className="mt-2.5 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{article.summary}</p>
      <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
        阅读全文
        <i className="ri-arrow-right-line text-sm leading-none transition-transform group-hover:translate-x-0.5" />
      </span>
    </Link>
  );
}